export default __webpack_public_path__ + "static/media/earth.32907f19.jpg";